import { createMuiTheme } from '@material-ui/core/styles';

export const themeValues = {
  palette: {
    black: {
      main: '#000000',
    },
    blue: {
      main: '#009dc1',
    },
    bobBlack: {
      main: '#212121',
    },
    error: {
      main : '#b00320',
      hover: '#7D0217',
    },
    green: {
      main: '#036B3F',
    },
    grey: {
      main  : '#666666',
      medium: '#DDDDDD',
      light : '#c5c1c1',
    },
    orange: {
      main : '#e86b3f',
      light: '#FF9800',
    },
    primary: {
      main: '#1973e8',
    },
    red: {
      main: '#b00320',
    },
    transparent: {
      main: 'rgba(0,0,0,0)',
    },
    warning: {
      main: '#e86b3f',
    },
    white: {
      main : '#ffffff',
      hover: '#d5d5d5',
    },
    purple: {
      main: '#9c27b0',
    },
    muiGrey: {
      main: '#aaaaaa',
    },
    borderGrey: {
      main: '#d2d2d2',
    },
    text: {
      main: '#495057',
    },
    success: {
      main: '#4CAF50',
    },
    // FIXME: Add to suply custom input styles
    labelGrey: {
      main: '#AAAAAA',
    },
  },
};

export default createMuiTheme({
  ...themeValues,
  typography: {
    allVariants: {
      fontFamily: 'Montserrat',
    },
    fontFamily: 'Montserrat',
    button    : {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiFormLabel: {
      root: {
        color         : themeValues.palette.labelGrey.main,
        display       : 'flex !important',
        flexDirection : 'row-reverse',
        gap           : '4px',
        justifyContent: 'flex-end',
      },
      asterisk: {
        color    : themeValues.palette.primary.main,
        '&$error': {
          color: themeValues.palette.error.main,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          borderColor: themeValues.palette.borderGrey.main,
        },
        '&:hover $notchedOutline': {
          borderColor: 'none',
        },
      },
    },
    MuiInput: {
      underline: {
        '&:hover:not($disabled):before': {
          borderBottom: `1px solid ${themeValues.palette.borderGrey.main}`,
        },
      },
    },
    MuiTextField: {
      root: {
        '& label': {
          fontSize  : '14px',
          fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
          fontWeight: '400',
          lineHeight: '1.42857',
          opacity   : '1',
        },
        '& .MuiInput-underline:before': {
          borderColor: themeValues.palette.borderGrey.main,
        },

        '& .MuiInput-underline:before:hover': {
          borderColor: themeValues.palette.borderGrey.main,
        },
        '& textarea': {
          fontSize  : '14px',
          fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
          fontWeight: '400',
          lineHeight: '1.42857',
          opacity   : '1',
        },
      },
    },
    MuiDialog: {
      paper: {
        margin: '0 12px',
      },
    },
    MuiFormControlLabel: {
      label: {
        color     : themeValues.palette.text.main,
        fontWeight: 600,
        fontSize  : '14px',
      },
    },
  },

});
